module.exports = __webpack_public_path__ + "img/breaker_off.11eb7a37.png";